import React from 'react';
import { Row, Col, Table } from 'react-bootstrap';
import { Calculator } from 'lucide-react';
import { formatINR } from '../../../../helper/bom';

const CostingTaxSummary = ({
  financials,
  formData,
  setFormData
}) => {
  return (
    <div className="border rounded-3 bg-white p-3 shadow-sm mb-3" style={{ borderColor: "#cbd5e1" }}>
      <div className="d-flex align-items-center mb-3 pb-2 border-bottom">
        <h6 className="mb-0 fw-bold text-dark d-flex align-items-center gap-2" style={{ fontSize: "14px" }}>
          <Calculator size={16} className="text-primary" />
          Costing Breakdown, Freight, Loading & Taxes
        </h6>
      </div>

      <Row className="g-3">
        {/* Charges Inputs */}
        <Col md={6}>
          <div className="p-3 border rounded bg-light h-100" style={{ borderColor: "#e2e8f0" }}>
            <span className="fw-bold text-muted d-block mb-3 text-uppercase" style={{ fontSize: "12px", letterSpacing: "0.5px" }}>
              Freight, Loading & Packaging Charges
            </span>

            <Row className="g-2">
              <Col sm={6}>
                <div className="mb-2">
                  <label className="fw-semibold text-dark mb-1" style={{ fontSize: "12px" }}>Packaging Charges (₹):</label>
                  <input
                    type="number"
                    className="form-control form-control-sm"
                    style={{ height: "34px", fontSize: "12px" }}
                    placeholder="0"
                    value={formData.packaging_charges}
                    onChange={(e) => setFormData({ ...formData, packaging_charges: e.target.value })}
                  />
                </div>
              </Col>
              <Col sm={6}>
                <div className="mb-2">
                  <label className="fw-semibold text-dark mb-1" style={{ fontSize: "12px" }}>Packaging GST (%):</label>
                  <input
                    type="number"
                    className="form-control form-control-sm"
                    style={{ height: "34px", fontSize: "12px" }}
                    placeholder="18"
                    value={formData.packaging_gst_percent}
                    onChange={(e) => setFormData({ ...formData, packaging_gst_percent: e.target.value })}
                  />
                </div>
              </Col>

              <Col sm={6}>
                <div className="mb-2">
                  <label className="fw-semibold text-dark mb-1" style={{ fontSize: "12px" }}>Loading Charges (₹):</label>
                  <input
                    type="number"
                    className="form-control form-control-sm"
                    style={{ height: "34px", fontSize: "12px" }}
                    placeholder="0"
                    value={formData.loading_charges}
                    onChange={(e) => setFormData({ ...formData, loading_charges: e.target.value })}
                  />
                </div>
              </Col>
              <Col sm={6}>
                <div className="mb-2">
                  <label className="fw-semibold text-dark mb-1" style={{ fontSize: "12px" }}>Loading GST (%):</label>
                  <input
                    type="number"
                    className="form-control form-control-sm"
                    style={{ height: "34px", fontSize: "12px" }}
                    placeholder="18"
                    value={formData.loading_gst_percent}
                    onChange={(e) => setFormData({ ...formData, loading_gst_percent: e.target.value })}
                  />
                </div>
              </Col>

              <Col sm={6}>
                <div className="mb-2">
                  <label className="fw-semibold text-dark mb-1" style={{ fontSize: "12px" }}>Freight Charges (₹):</label>
                  <input
                    type="number"
                    className="form-control form-control-sm"
                    style={{ height: "34px", fontSize: "12px" }}
                    placeholder="0"
                    value={formData.freight_charges}
                    onChange={(e) => setFormData({ ...formData, freight_charges: e.target.value })}
                  />
                </div>
              </Col>
              <Col sm={6}>
                <div className="mb-2">
                  <label className="fw-semibold text-dark mb-1" style={{ fontSize: "12px" }}>Freight GST (%):</label>
                  <input
                    type="number"
                    className="form-control form-control-sm"
                    style={{ height: "34px", fontSize: "12px" }}
                    placeholder="18"
                    value={formData.freight_gst_percent}
                    onChange={(e) => setFormData({ ...formData, freight_gst_percent: e.target.value })}
                  />
                </div>
              </Col>

              <Col sm={6}>
                <div className="mb-2">
                  <label className="fw-semibold text-dark mb-1" style={{ fontSize: "12px" }}>Material / Assembly GST (%):</label>
                  <input
                    type="number"
                    className="form-control form-control-sm"
                    style={{ height: "34px", fontSize: "12px" }}
                    placeholder="18"
                    value={formData.gst_percent}
                    onChange={(e) => setFormData({ ...formData, gst_percent: e.target.value })}
                  />
                </div>
              </Col>
              <Col sm={6}>
                <div className="mb-2">
                  <label className="fw-semibold text-dark mb-1" style={{ fontSize: "12px" }}>Other Charges (₹):</label>
                  <input
                    type="number"
                    className="form-control form-control-sm"
                    style={{ height: "34px", fontSize: "12px" }}
                    placeholder="0"
                    value={formData.other_charges}
                    onChange={(e) => setFormData({ ...formData, other_charges: e.target.value })}
                  />
                </div>
              </Col>
            </Row>
          </div>
        </Col>

        {/* Commercial Ledger Table */}
        <Col md={6}>
          <div className="border rounded bg-white p-2 h-100 d-flex flex-column justify-content-between" style={{ borderColor: "#e2e8f0" }}>
            <Table bordered size="sm" className="mb-2 align-middle" style={{ fontSize: "12px" }}>
              <tbody>
                <tr>
                  <td className="text-muted py-2 px-3">Assembly Subtotal:</td>
                  <td className="text-end fw-bold py-2 px-3">{formatINR(financials.subtotal_amount)}</td>
                </tr>
                {financials.packaging_charges > 0 && (
                  <tr>
                    <td className="text-muted py-2 px-3">Packaging Charges ({formData.packaging_gst_percent}% GST):</td>
                    <td className="text-end py-2 px-3">{formatINR(financials.packaging_charges)}</td>
                  </tr>
                )}
                {financials.loading_charges > 0 && (
                  <tr>
                    <td className="text-muted py-2 px-3">Loading Charges ({formData.loading_gst_percent}% GST):</td>
                    <td className="text-end py-2 px-3">{formatINR(financials.loading_charges)}</td>
                  </tr>
                )}
                {financials.freight_charges > 0 && (
                  <tr>
                    <td className="text-muted py-2 px-3">Freight Charges ({formData.freight_gst_percent}% GST):</td>
                    <td className="text-end py-2 px-3">{formatINR(financials.freight_charges)}</td>
                  </tr>
                )}
                <tr className="table-light">
                  <td className="fw-bold py-2 px-3">Total Taxable Value:</td>
                  <td className="text-end fw-bold py-2 px-3">{formatINR(financials.taxable_amount)}</td>
                </tr>
                {financials.cgst_amount > 0 ? (
                  <>
                    <tr>
                      <td className="text-muted py-2 px-3">CGST:</td>
                      <td className="text-end py-2 px-3">{formatINR(financials.cgst_amount)}</td>
                    </tr>
                    <tr>
                      <td className="text-muted py-2 px-3">SGST:</td>
                      <td className="text-end py-2 px-3">{formatINR(financials.sgst_amount)}</td>
                    </tr>
                  </>
                ) : (
                  <tr>
                    <td className="text-muted py-2 px-3">IGST:</td>
                    <td className="text-end py-2 px-3">{formatINR(financials.igst_amount)}</td>
                  </tr>
                )}
                <tr>
                  <td className="text-muted py-2 px-3">Round Off:</td>
                  <td className="text-end py-2 px-3">{financials.round_off >= 0 ? '+' : ''}{financials.round_off}</td>
                </tr>
                <tr style={{ backgroundColor: "#e0f2fe" }}>
                  <td className="fw-bold text-primary py-2 px-3" style={{ fontSize: "13px" }}>GRAND TOTAL:</td>
                  <td className="text-end fw-bold text-primary py-2 px-3" style={{ fontSize: "14px" }}>
                    {formatINR(financials.grand_total)}
                  </td>
                </tr>
              </tbody>
            </Table>
            <div className="p-2 bg-light rounded text-dark border" style={{ fontSize: "11.5px" }}>
              <strong>In Words:</strong> {financials.amount_in_words || "-"}
            </div>
          </div>
        </Col>
      </Row>
    </div>
  );
};

export default CostingTaxSummary;
